// 2026-07-16 slate: Mon Connections, Thu+Sun Decode, Wed+Sat Grid, Tue+Fri
// Duel. All 7 days covered — SPOT is RETIRED to archive-only (the 'spot'
// fallback below is unreachable). Keep in sync with the worker copy in
// apps/game/src/services/daily-game.ts.
export const CONNECTIONS_WEEKDAYS: number[] = [1]; // Monday
export const DECODE_WEEKDAYS: number[] = [0, 4]; // Thursday + Sunday
export const GRID_ENABLED = true;
export const GRID_WEEKDAYS: number[] = GRID_ENABLED ? [3, 6] : []; // Wed + Sat
export const DUEL_WEEKDAYS: number[] = [2, 5]; // Tuesday + Friday
const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export function easternWeekday(date: Date): number {
  return DAYS.indexOf(
    date.toLocaleDateString('en-US', {
      timeZone: 'America/New_York',
      weekday: 'short',
    }),
  );
}
export function dailyGame(
  date: Date,
): 'connections' | 'decode' | 'grid' | 'duel' | 'spot' {
  const wd = easternWeekday(date);
  if (CONNECTIONS_WEEKDAYS.includes(wd)) return 'connections';
  if (DECODE_WEEKDAYS.includes(wd)) return 'decode';
  if (GRID_WEEKDAYS.includes(wd)) return 'grid';
  if (DUEL_WEEKDAYS.includes(wd)) return 'duel';
  return 'spot';
}
